import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { getFullDetailsOfCourse } from "../services/operations/courseDetailsAPI";
import { setCompletedLectures, setCourseSectionData, setEntireCourseData, setTotalNoOfLectures } from "../slices/viewCourseSlice";
import VideoDetailsSidebar from "../components/core/ViewCourse/VideoDetailsSidebar";
import CourseReviewModal from "../components/core/ViewCourse/CourseReviewModal";

function ViewCourse(props) {
  const [reviewModal, setReviewModal] = useState(false);
  const { courseId } = useParams();
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const setCourseSpecificDetails = async () => {
        const courseData = await getFullDetailsOfCourse(courseId, token);
        // console.log("Course Details: ", courseData);
        dispatch(setCourseSectionData(courseData.courseDetails.courseContent));
        dispatch(setEntireCourseData(courseData.courseDetails));
        dispatch(setCompletedLectures(courseData.completedVideos));

        let lectures = 0;
        courseData?.courseDetails?.courseContent?.forEach((sec)=>{
            lectures += sec.subSection.length
        })

        dispatch(setTotalNoOfLectures(lectures));
        
         /*
        {
    "success": true,
    "data": {
        "courseDetails": {
            "_id": "65c4fc770fb83ae12dcb06cd",
            "courseName": "Course 1",
            "courseDescription": "Course 1",
            "instructor": {
                "_id": "65a2ba78c3b415c89568f363",
                "firstName": "Anubhav",
                "lastName": "GhoshInstructor",
                "email": "anubhavghosh03@gmail.com",
                "password": "$2b$10$smJ.nu8FxKy.2hETEx1g9uxS4/GazkKDqjZ6.1Ioj4dWFi7ZskznW",
                "accountType": "Instructor",
                "additionalDetails": {
                    "_id": "65a2ba78c3b415c89568f361",
                    "gender": null,
                    "dateOfBirth": null,
                    "about": null,
                    "contactNumber": null,
                    "__v": 0
                },
                "courses": [
                    "65c505e5dfd3387cef8c4a58",
                    "65c5c5c9bb9d0e5328844394",
                    "65ca3876ed62d8ce3cef4a41"
                ],
                "image": "https://api.dicebear.com/7.x/initials/svg?seed=Anubhav GhoshInstructor",
                "courseProgress": [],
                "active": true,
                "approved": true,
                "createdAt": "2024-01-13T16:29:44.863Z",
                "updatedAt": "2024-02-12T15:25:42.610Z",
                "__v": 0,
                "resetPasswordExpires": "2024-01-28T04:59:38.540Z",
                "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFudWJoYXZnaG9zaDAzQGdtYWlsLmNvbSIsImlkIjoiNjVhMmJhNzhjM2I0MTVjODk1NjhmMzYzIiwiYWNjb3VudFR5cGUiOiJJbnN0cnVjdG9yIiwiaWF0IjoxNzA3NzUxMjM1LCJleHAiOjE3MDc4Mzc2MzV9.QwXz6_j5CRavINO7Y7j0KHB7VdQlIcFqCx8eWsoJPDc"
            },
            "whatYouWillLearn": "Course 1",
            "courseContent": [
                {
                    "_id": "65c4fc7a0fb83ae12dcb06d1",
                    "sectionName": "Course 1",
                    "subSection": [
                        {
                            "_id": "65c4fc9f0fb83ae12dcb06d5",
                            "title": "Lecture 1",
                            "timeDuration": "39.839",
                            "description": "Lecture 1",
                            "videoUrl": "https://res.cloudinary.com/dzg7eemfm/video/upload/v1707408542/StudyNotion/igqic6rtsb2lohnbqdxl.webm",
                            "__v": 0
                        }
                    ],
                    "__v": 0
                }
            ],
            "ratingAndReviews": [],
            "price": 999,
            "thumbnail": "https://res.cloudinary.com/dzg7eemfm/image/upload/v1707408502/StudyNotion/pix4ba5pldzntlts4hfu.png",
            "tag": [
                "[\"Course 1\"]"
            ],
            "category": {
                "_id": "65a2b76969a800180f2f3955",
                "name": "Devops",
                "description": "Python is a Famous Programming Language",
                "course": [
                    "65a2bb5c23d697f5ca8ad248",
                    "65a2bcc727c42442f8b324a3",
                    "65ba6f7f6e2a9e35fb4a23c3",
                    "65bb22bae0b660fa73e62a0d",
                    "65bb232be0b660fa73e62a15",
                    "65bb2506e0b660fa73e62a1d",
                    "65bb280ce0b660fa73e62a25",
                    "65bbc7fa0c2718bc1f446e08",
                    "65bbcbba0c2718bc1f446e14",
                    "65bbcce1c6b605b76c33cae9",
                    "65bbcd87c6b605b76c33cafd",
                    "65bbcf75c6b605b76c33cb25",
                    "65bbd06a37a444323560477f",
                    "65bbd25037a44432356047a0",
                    "65bbe24837a44432356047b2",
                    "65bbe2d3e853ef0b033c2023",
                    "65bd19dd572ae3aa376ac204",
                    "65bd1c29572ae3aa376ac210",
                    "65bd1dbb572ae3aa376ac21c",
                    "65bd2277669c9f8a4fd14b43",
                    "65bd282bd2c2901a4db1a075",
                    "65c505e5dfd3387cef8c4a58",
                    "65c5c5c9bb9d0e5328844394",
                    "65ca3876ed62d8ce3cef4a41"
                ],
                "__v": 0
            },
            "studentEnrolled": [],
            "instructions": [
                "[\"Course 1\"]"
            ],
            "status": "Published",
            "__v": 0,
            "createdAt": "2024-02-13T18:04:43.574Z"
        },
        "totalDuration": "39s",
        "completedVideos": []
    }
}
         */

    };
    setCourseSpecificDetails();
  }, []);

  return (
    <div>
      <div className="relative flex min-h-[calc(100vh-3.5rem)]">
        {/* <div className="w-[15%] h-screen"> */}
        <VideoDetailsSidebar setReviewModal={setReviewModal}/>
        {/* </div> */}
        <div className="h-[calc(100vh-3.5rem)] flex-1 overflow-auto">
            {/* <div className="w-full"> */}
            <div className="">
            <Outlet />
            </div>
        </div>
            {reviewModal ? (<CourseReviewModal setReviewModal={setReviewModal} />):("")}
      </div>
    </div>
  );
}

export default ViewCourse;